import styled from 'styled-components';
var GradientSVG = styled.svg.withConfig({
  displayName: "SVGGradientstyle__GradientSVG",
  componentId: "sc-q7jf99-0"
})(["position:absolute;width:0;height:0;"]);
export { GradientSVG };